import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Dialog from '..'
import { ButtonRounded } from '../..'
import { GuidanceIcon, PadlockIcon, ChevronIcon } from '../../icons'
import styles from './styles'
import { HOST } from '../../../utils/env'

const renderTitle = () => (
  <Fragment>
    <GuidanceIcon />
    This episode contains a guidance warning
  </Fragment>
)

const renderSuplementaryText = title => (
  <Fragment>
    This episode {title ? `of ${title}` : ''} has been G-rated. By choosing &quot;Yes&quot; you are confirming that you are over 18 and have read and agreed to our <a href="http://my.stv.tv/terms-of-use" target="_blank" rel="noopener noreferrer">terms and conditions</a> and wish to view this programme.
  </Fragment>
)

const GuidanceDialog = ({
  guidanceText,
  onGuidanceAccept,
  title,
}) => (
  <div className="GuidanceDialog">
    <Dialog
      title={renderTitle()}
      subtitle={`"${guidanceText}"`}
      supplementaryText={renderSuplementaryText(title)}
    />
    <div className="button-group">
      <ButtonRounded
        text="No"
        theme="dark"
        uppercase
        onClick={() => window.history.back()}
      />
      <ButtonRounded
        text="Yes"
        onClick={onGuidanceAccept}
        icon={<ChevronIcon />}
        uppercase
      />
    </div>
    <p className="parental-controls-info">The STV Player has a parental control option which allows you to set a PIN to restrict access to programming with guidance warnings.</p>
    <a
      className="parental-controls-link"
      href={`//player.${HOST}/settings?redirect=true`}
    >
      <PadlockIcon color="#bbb" width="1em" height="1em" />
      Set Parental Controls
    </a>
    <style jsx>{styles}</style>
  </div>
)

GuidanceDialog.propTypes = {
  guidanceText: PropTypes.string.isRequired,
  onGuidanceAccept: PropTypes.func.isRequired,
  title: PropTypes.string,
}

GuidanceDialog.defaultProps = {
  title: null,
}

export default GuidanceDialog
